import {
    Drawer,
    DrawerProps,
    ScrollArea
} from '@mantine/core';
import {RecordForm} from "../forms/RecordForm.tsx";
import config from "../config";
import {PipelineRecordFormProps} from "../types.ts";


export const FormDrawer = (
    {
        record,
        handleSubmit,
        opened,
        onClose,
        ...rest
    }: DrawerProps & Omit<PipelineRecordFormProps, 'handleCancel'>) => {

    const title = record.id
        ? `Edit ${config.titles.singular}`
        : `New ${config.titles.singular}`

    return (
        <Drawer
            transitionProps={{
                transition: "slide-up",
                duration: 750,
                timingFunction: "ease"
            }}
            position="right"
            offset={10}
            opened={opened}
            onClose={onClose}
            title={title}
            padding="xl"
            size="xl"
            scrollAreaComponent={ScrollArea.Autosize}
            {...rest}
        >
            <RecordForm
                record={record}
                // Close only AFTER the mutation resolves. Closing on the same
                // tick discarded the operator's edits whenever the server
                // rejected the write — a duplicate name, a resolver validation
                // failure — and surfaced the error toast over an empty drawer.
                handleSubmit={async (values) => {
                    await handleSubmit(values);
                    onClose();
                }}
                handleCancel={onClose}
            />
        </Drawer>
    )
};
